(function () {
  function formatMoney(amount, currency) {
    var rounded = Math.ceil(amount);
    var code = (currency || 'HKD').toUpperCase();
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(rounded);
    } catch (e) {
      return code + ' ' + rounded;
    }
  }

  function presentmentRate() {
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      var rate = parseFloat(Shopify.currency.rate);
      if (rate && rate > 0) return rate;
    }
    return 1;
  }

  /**
   * Compare cart (presentment cents) to a threshold defined in thresholdCurrency.
   * Shop currency is usually HKD. Shopify.currency.rate = presentment per 1 shop unit.
   */
  function thresholdInCartCents(thresholdMajor, thresholdCurrency, cartCurrency, shopCurrency) {
    var from = (thresholdCurrency || 'HKD').toUpperCase();
    var cart = (cartCurrency || 'HKD').toUpperCase();
    var shop = (shopCurrency || 'HKD').toUpperCase();
    var rate = presentmentRate();

    if (from === cart) {
      return Math.round(thresholdMajor * 100);
    }

    // Threshold in shop currency → presentment/cart cents
    if (from === shop) {
      return Math.round(thresholdMajor * rate * 100);
    }

    // Threshold in another currency (e.g. USD) while cart is shop currency (HKD):
    // when presentment is that currency, rate is cart/shop, so shop = cart/rate → invert.
    if (cart === shop) {
      return Math.round((thresholdMajor / rate) * 100);
    }

    // Threshold USD, cart GBP (or other): convert threshold → shop → cart
    // Only accurate when Shopify.currency.active matches cart; rate is cart/shop.
    // Without a USD rate, fall back to treating threshold as presentment major units.
    return Math.round(thresholdMajor * 100);
  }

  function updateBar(el) {
    if (!el || el.hasAttribute('hidden')) return;

    var thresholdCentsAttr = parseInt(el.getAttribute('data-threshold-cents'), 10);
    if (!thresholdCentsAttr && thresholdCentsAttr !== 0) {
      thresholdCentsAttr = parseInt(el.getAttribute('data-threshold-hkd-cents'), 10) || 0;
    }
    if (thresholdCentsAttr <= 0) return;

    var thresholdCurrency = (el.getAttribute('data-threshold-currency') || 'HKD').toUpperCase();
    var cartTotal = parseInt(el.getAttribute('data-cart-total'), 10) || 0;
    var cartCurrency = (el.getAttribute('data-cart-currency') || 'HKD').toUpperCase();
    var shopCurrency = (el.getAttribute('data-shop-currency') || 'HKD').toUpperCase();

    var thresholdCartCents = thresholdInCartCents(
      thresholdCentsAttr / 100,
      thresholdCurrency,
      cartCurrency,
      shopCurrency
    );
    if (thresholdCartCents <= 0) return;

    var remainingCents = Math.max(thresholdCartCents - cartTotal, 0);
    var progress = Math.min(100, Math.max(0, Math.round((cartTotal / thresholdCartCents) * 100)));

    var textEl = el.querySelector('[data-free-shipping-text]');
    var fillEl = el.querySelector('[data-free-shipping-fill]');
    var pctEl = el.querySelector('[data-free-shipping-pct]');
    var trackEl = el.querySelector('[data-free-shipping-track]');

    var msgUnlocked = el.getAttribute('data-msg-unlocked') || "You've unlocked FREE shipping!";
    var msgAddMore = el.getAttribute('data-msg-add-more') || 'Add {{ amount }} more for FREE shipping!';

    if (remainingCents <= 0) {
      if (textEl) textEl.textContent = msgUnlocked;
      el.classList.add('free-shipping-bar--unlocked');
      progress = 100;
    } else {
      el.classList.remove('free-shipping-bar--unlocked');
      if (textEl) {
        textEl.textContent = msgAddMore.replace(
          '{{ amount }}',
          formatMoney(remainingCents / 100, cartCurrency)
        );
      }
    }

    if (fillEl) fillEl.style.width = progress + '%';
    if (pctEl) pctEl.textContent = progress + '%';
    if (trackEl) trackEl.setAttribute('aria-valuenow', String(progress));
  }

  function updateAll(scope) {
    (scope || document).querySelectorAll('[data-free-shipping-bar]').forEach(updateBar);
  }

  function bind() {
    updateAll(document);

    document.addEventListener('cart:updated', function () {
      updateAll(document);
    });

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('[data-free-shipping-bar]')) {
              updateBar(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('[data-free-shipping-bar]').forEach(updateBar);
            }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  window.VennassaFreeShippingBar = { updateAll: updateAll };
})();
